import React from "react";

// Images
import mainSponsorImg from "../images/sponsors/main.png";
import platinumSponsorImg from "../images/sponsors/platinum.png";
import diamondSponsorImg from "../images/sponsors/diamond.png";
import goldSponsorImg from "../images/sponsors/gold2025.png";
import silverSponsorImg from "../images/sponsors/silver.png";
import supportMediaImg from "../images/sponsors/supporting-media.png";
import supportAssociationImg from "../images/sponsors/supporting-association2025.png";
import supportBodiesImg from "../images/sponsors/cidb.png";

// Constant Data
const sponsors = [
  // { img: mainSponsorImg, alt: "Top Mix Go Green", title: "Main Sponsor" },
  { img: diamondSponsorImg, alt: "Saint-Gobain", title: "Diamond Sponsor" },
  { img: goldSponsorImg, alt: "Geometry Multiample", title: "Gold Sponsor" },
  // {
  //   img: silverSponsorImg,
  //   alt: "Tac Group, Big Bath, MLG, Global Titanum Coating, Redawn, Smartpools",
  //   title: "Silver Sponsor",
  // },
  // {
  //   img: supportMediaImg,
  //   alt: "Hms, ACG MEDIA, Paparazzi, The Page",
  //   title: "Supporting Media",
  // },
  {
    img: supportAssociationImg,
    alt: "PAM, MBAM, miid, KSFA, JIDA, FMBA, acam",
    title: "Supporting Association",
  },
  { img: supportBodiesImg, alt: "Supporting Bodies", title: "Supporting Bodies" },
];

function SponsorList() {
  return (
    <div className="bg-white p-y-30">
      <div className="container flex flex-col a-i-center j-c-center">
        {sponsors.map((el) => (
          <div
            className="flex flex-col a-i-center j-c-center gap-25 m-b-50"
            key={el.title}
          >
            <h1 className="text-uppercase text-center">{el.title}</h1>
            <img
              className="full-width"
              style={{maxWidth: "250px"}}
              src={el.img}
              alt={el.alt}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default SponsorList;
